import Vue from 'vue'
import Component from 'vue-class-component'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI, {Message} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 计划 05a-2 任务 6：让 vue-router 的三个导航守卫钩子能在 vue-property-decorator 类组件里
// 直接声明为实例方法（如 UnifiedEditor.beforeRouteLeave）。
//
// vue-class-component 只把一份内置白名单（$internalHooks：data/beforeCreate/mounted 等 14 个
// Vue 原生生命周期）里的方法名提升为组件的顶层 option，其余类方法一律进 options.methods。
// 而 vue-router 的 extractGuard 读的是 def.options[key]（顶层），不会去 options.methods 里找。
// 所以类组件里直接写 beforeRouteLeave 会被编译进 options.methods，vue-router 读不到，
// 守卫静默不生效——编译不报错、运行不报错，只是永远不跑。必须在这里显式注册，且要在任何
// 用到这三个钩子的组件被 `@Component` 装饰之前调用——这些组件即使懒加载，模块求值也一定
// 晚于应用启动时的这一行，注册时机不受哪个组件懒加载影响。
//
//（计划 05a-2 任务 6 实测确认：用本项目实装的 vue@2.6.14 / vue-class-component@7.2.3 /
// vue-router@3.5.1 起一个隔离探针——不注册时 vue-router 的 extractGuard 拿到 undefined，
// 注册后拿到合法的 hook。）
Component.registerHooks(['beforeRouteEnter', 'beforeRouteUpdate', 'beforeRouteLeave'])

// 全局错误处理 - 捕获并显示详细错误信息
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error:', err)
  console.error('Error Info:', info)
  console.error('Component:', vm)
  console.error('Stack:', err.stack)
  
  // 显示带有详细信息的错误提示
  Message.error({
    message: `错误: ${err.message}\n位置: ${info}\n查看控制台获取详细信息`,
    duration: 5000,
    showClose: true
  })
}

// 捕获未处理的 Promise 错误
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled Promise Rejection:', event.reason)
  console.error('Promise:', event.promise)
  Message.error({
    message: `Promise 错误: ${event.reason}\n查看控制台获取详细信息`,
    duration: 5000,
    showClose: true
  })
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
